import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Root path: route to the plans list when signed in, otherwise to sign-in.
 * This is the only place in the app that decides where "/" lands; both
 * targets handle their own further auth gating.
 */
export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    if (context.authStatus === 'authenticated') {
      throw redirect({ to: '/plans' });
    }
    throw redirect({ to: '/sign-in' });
  },
});
